<template>
  <div
    v-if="item?.isDisplay && item?.IsShow"
    class="opple-config-platform"
  >
    <TopBar
      ref="Platform"
      :device="device"
      :is-delete-loading="isDeleteLoading"
      @selectAll="selectAll"
      @showDeviceDialog="showDeviceDialog"
      @deleteDevice="onDeleteDevice" 
    />
    <div
      class="opple-config-platform_list"
    >
      <i
        v-if="isAddLoading"
        class="el-icon-loading"
      />
      <div
        v-if="!isAddLoading && deviceCardList.length === 0"
        class="opple-config-platform_list-noData"
      >
        <img :src="noData">
        <p>{{ $t('deviceMsg.noRelationDevice') }}</p>
      </div>
      <template v-if="!isAddLoading && deviceCardList.length !== 0">
        <OppleDeviceCard 
          v-for="(card, index) in deviceCardList"
          :key="index"
          :data="card"
          :select-type="selectType"
          @select="onSelect"
        />
      </template>
    </div>
    <el-dialog
      :visible="isDeviceDialogVisable"
      class="dialogGroup choose_device"
      :before-close="handlerClose"
      top="0"
      append-to-body
    >
      <op-device-choose
        v-if="isDeviceDialogVisable"
        ref="opDeviceChoose"
        class="content"
        :is_group="false"
        :areaid="gpNo"
        :execute-type="1"
        :displaynoarea="true"
        :triggledevice="true"
        :child-category-type="4"
        :gateway-v-device-id="device.ParentVDeviceId"
        :checkeddata="checkeddata"
        :only-class-sku="onlyClassSku"
        @confirm="deviceValueChange"
      />
    </el-dialog>
  </div>
</template>

<script>
import OppleDeviceCard from '@/components/OppleDeviceCard/index.vue';
// import OpDeviceChoose from '@/components/common/OpDeviceChoose.vue';
import TopBar from './TopBar.vue';
import noData from '@/assets/img/no-data.png';
import {
  FindLightInterlockingSwitchDeviceListByCommandValue,
} from '@/axios/IDevice.js'
import {LITE_PANEL_CLASSSKU} from '@/utils/enums'

export default {
  name: 'OppleConfigPlatform',
  components: {
    OppleDeviceCard,
    // OpDeviceChoose,
    TopBar
  },
  props: {
    selectType: {
      type: Number,
      default: 1
    },
    item: {
      type: Object,
      default: () => ({})
    },
    device: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      checkeddata: [],
      gpNo: -1,
      currentTab: 0,
      isAddLoading: false,
      isDeleteLoading: false,
      isDeviceDialogVisable: false,
      deviceCardList: [],
      noData,
      onlyClassSku:LITE_PANEL_CLASSSKU
    };
  },

  computed: {
    postDeviceMacData(){
      const macData = this.checkeddata.reduce((accumulator, currentValue) => accumulator + currentValue.Mac ,"")
      return macData
    }
  },

  watch: {
    device(value) {
      this.requestRelationDeviceList();
      // this.setCom();
    },
  },
    

  mounted() {
    this.requestRelationDeviceList();
    console.log(this.device.ParentVDeviceId)
    console.log(this.item)
  },

  methods: {


      /* 格式化设备数据
     * item：设备对象
     */
     formatedevicestatus(item) {
      //格式化设备状态
      if (item.StatusInfo) {
        if (item.StatusInfo != null && item.StatusInfo != "") {
          var isReturn = false;
          item.StatusInfo.forEach((n) => {
            if (n.StatusType == "0x0600") {
              this.getilluminationValue(n);
            } else if (n.StatusType == "0x0700") {
              this.gettemperatureValue(n);
            } else if (n.StatusType == "0x1600" || n.StatusType == "0x1601") {
              //上电时长/开灯时长 界面将秒转成小时
              this.getpowertimeValue(n);
            }
            isReturn = false;
            this.$store.state.deiveStatus.forEach((m) => {
              if (m.Key == n.StatusType) {
                //校准匹配 isReturn = true;
                m.Value.forEach((t) => {
                  if (t.Value != undefined) {
                    if (t.Value == n.Value) {
                      n.Value1 = n.Value;
                      n.Value = t.Key;
                      n.ParaUnit = "";
                      isReturn = true;
                    }
                  } else {
                    //console.log(n.Name+":"+n.Value);
                  }
                  // else {
                  // 	var _value = Number(n.Value);
                  // 	if (_value >= t.Min && _value < t.Max) {
                  // 		n.Value = t.Key;
                  // 		n.ParaUnit="";
                  //
                  // 	}
                  // }
                });
              }
            });
            if (isReturn == true) {
              return;
            }

            this.$store.state.deiveStatus.forEach((m) => {
              if (m.Key == n.StatusType.substring(0, 4)) {
                //匹配大类
                m.Value.forEach((t) => {
                  if (t.Value != undefined) {
                    if (t.Value == n.Value) {
                      n.Value1 = n.Value;
                      n.Value = t.Key;
                      n.ParaUnit = "";
                    }
                  } else {
                    //console.log(n.Name+":"+n.Value);
                  }
                  // else {
                  // 	var _value = Number(n.Value);
                  // 	if (_value >= t.Min && _value < t.Max) {
                  // 		n.Value = t.Key;
                  // 		n.ParaUnit="";
                  //
                  // 	}
                  // }
                });
              }
            });
          });
        }
      }
    },
    async requestRelationDeviceList() {
      try {
        const res = await FindLightInterlockingSwitchDeviceListByCommandValue({
          vDeviceId: this.device.VDeviceId,
          commandValue: this.item.DefaultValue,
        });
        const list = (res.Result || []).map(item => {
          const info = item.StatusInfo || '{}';
          const StatusInfo = JSON.parse(info);
          const result = {
            ...item,
            StatusInfo
          } 
          this.formatedevicestatus(result);
          return result
          
        });

        this.deviceCardList = list;
        // 不选择这个设备本身 因为设备不能关联自己
        this.checkeddata = list;
      } catch (e) {

      }
    },
    
    onItemClick(tab) {
      this.currentTab = tab;
    },
  
    selectAll() {
      this.deviceCardList = this.deviceCardList.map((item) => ({ ...item, checked: true }))
    },
  
    onSelect(data, isCheck) {
      if (this.selectType === 1) {
        this.deviceCardList = this.deviceCardList.map((item) => {
          if (
            item.ClassSku === data.ClassSku &&
            item.VDeviceId === data.VDeviceId
          ) {
            return {
              ...item,
              checked: isCheck
            }
          }

          return {
            ...item,
            // checked: !!isCheck ? false : item.checked
          }
        })
      }
      console.log('data', data, isCheck, this.deviceCardList);
    },
    showDeviceDialog() {
      this.isDeviceDialogVisable = true;
    },
    handlerClose() {
      this.isDeviceDialogVisable = false;
    },

    async deviceValueChange(devlices) {
      const deviceCardList = [...this.deviceCardList,...devlices];

      if (deviceCardList.length < this.item.Min || deviceCardList.length > this.item.Max) {
          this.$message({
            type: "warning",
            message: `${this.$t('adddevice.least')}${this.item.Min}, ${this.$t('adddevice.upTo')}${this.item.Max}`
          })
          return;
      }
      
      try {
        this.isAddLoading = true;

        this.handlerClose();

        this.checkeddata = [...this.checkeddata,...devlices] 
        this.deviceCardList = deviceCardList;

        // const res = await AddDeviceRelation(relativeDevices);

        // await this.requestRelationDeviceList();

        this.isAddLoading = false;
      } catch (e) {
        this.isAddLoading = false;
      }
      // console.log('devlices', relativeDevices);
    },

    async onDeleteDevice() {
      // 排除设备自己
      const checkeddata = this.deviceCardList.filter(device => !device.checked).filter(
        device => device.ChildId !== this.device.ChildId || 
          device.ClassSku !== this.device.ClassSku ||
          device.DeviceId !== this.device.DeviceId ||
          device.VDeviceId !== this.device.VDeviceId
        )
      console.log("🚀 ~ file: OppleAbilityPanel.vue:224 ~ onDeleteDevice ~ checkeddata:", checkeddata)

      // const req = checkeddata.map(device => ({
      //   RelationId: device.DeviceId,
      //   DeviceId: this.device.DeviceId,
      //   UserFavoritesType: 1
      // }));

      try {
        this.isDeleteLoading = true;
        this.deviceCardList = checkeddata;
        // 不选择这个设备本身 因为设备不能关联自己
        this.checkeddata = checkeddata;
        // const res = await RemoveDeviceRelation(req);

        // await this.requestRelationDeviceList();

        this.isDeleteLoading = false;
      } catch (e) {
        this.isDeleteLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">

.opple-config-platform {
  flex: 1;

  &_list {
    display: flex;
    flex-wrap: wrap;
    &-noData {
      margin: 0 auto;
      width: 280px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #9E9E9E;
  
      img {
        width: 100%;
        margin-bottom: 10px;
      }
    }

    .el-icon-loading {
    margin: 10px 100px;
  }
  }

  .opple-device-card {
    margin: 10px;
  }
}
.opple-device-card{
    width: 192px !important;
    height: 187px !important;
    // &_control_main{
    //   line-height: 0;
    // }
}
</style>
